import { Moon, Sun } from "lucide-react";
import React from "react";
import { useTheme } from "../../context/ThemeContext";

export const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle relative inline-flex h-9 w-[76px] items-center rounded-full border border-white/20 px-1"
      aria-label="Toggle dark and light mode"
      data-testid="theme-toggle-switch"
      type="button"
    >
      <span className="sr-only">Theme switch</span>
      <span
        className={`theme-toggle-thumb absolute top-1 h-7 w-7 rounded-full bg-[#c2a45d] transition-transform duration-300 ${
          isDark ? "translate-x-0" : "translate-x-[40px]"
        }`}
        data-testid="theme-toggle-thumb"
      />
      <span className="relative z-10 grid w-full grid-cols-2 place-items-center text-xs">
        <Moon size={14} className={`${isDark ? "text-black" : "text-[#7d7566]"}`} data-testid="theme-toggle-moon-icon" />
        <Sun size={14} className={`${isDark ? "text-[#7d7566]" : "text-black"}`} data-testid="theme-toggle-sun-icon" />
      </span>
    </button>
  );
};
